// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const DefaultScopeSuffix = "/.default";

export const imdsHost = "http://169.254.169.254";
export const imdsEndpointPath = "/metadata/identity/oauth2/token";
export const imdsApiVersion = "2018-02-01";
export const azureArcAPIVersion = "2019-11-01";
export const azureFabricVersion = "2019-07-01-preview";
